import * as Commands from './commands';
import * as Actions from './actions';

interface ActionToCommandMap {
  command: new (...args) => Commands.Command<any>;
  action: new (...args) => object;
}

export const actionToCommandMappings: Array<ActionToCommandMap> = [
  {
    command: Commands.ObjectDeleteCommand,
    action: Actions.ObjectDeleteAction
  },
  {
    command: Commands.DeleteWallCommand,
    action: Actions.DeleteWallAction
  },
  {
    command: Commands.SaveObjectsTransformCommand,
    action: Actions.SaveObjectsTransformAction
  },
  {
    command: Commands.AddObjectCommand,
    action: Actions.AddObjectAction
  },
  {
    command: Commands.AddTierCommand,
    action: Actions.AddTierAction
  },
  {
    command: Commands.AddStairsCommand,
    action: Actions.AddStairsAction
  },
  {
    command: Commands.ChangeMaterialCommand,
    action: Actions.ChangeMaterialAction
  },
  {
    command: Commands.EditFloorShapeCommand,
    action: Actions.EditFloorShapeAction
  },
  {
    command: Commands.AddWallCommand,
    action: Actions.AddWallAction
  },
  {
    command: Commands.ChangeWallSizeCommand,
    action: Actions.ChangeWallSizeAction
  },
  {
    command: Commands.ChangeStairsTransformationCommand,
    action: Actions.ChangeStairsTransformationAction
  },
  {
    command: Commands.ResizeTierCommand,
    action: Actions.ResizeTierAction
  },
  {
    command: Commands.TierStepSizeChangeCommand,
    action: Actions.TierStepSizeChangeAction
  },
  {
    command: Commands.SetHeightCommand,
    action: Actions.SetHeightAction
  }
];



// WEBPACK FOOTER //
// ./src/app/services/eventLog/ActionToCommandMap.ts